import { LogLevels } from './types/LogLevels';
import * as consoleLogger from './consoleLogger';
import * as apiLogger from './apiLogger';

interface LoggerOptions {
    logLevel?: LogLevels;
    enableApiLogging?: boolean;
    enableConsoleLogging?: boolean;
    apiLoggingUrl?: string;
    sessionId?: string;
    clientId?: string;
}

let settings = {
    logLevel: 'Info',
    enableApiLogging: false,
    enableConsoleLogging: false,
    apiLoggingUrl: '/api/Logging'
};

export function configure(options: LoggerOptions) {
    settings = {
        ...settings,
        ...options
    }

    apiLogger.configure({
        url: options.apiLoggingUrl,
        clientId: options.clientId,
        sessionId: options.sessionId
    })
}

export function log(level: LogLevels, message: string) {
    if (shouldLog(level)) {
        const date = new Date(Date.now());

        if (settings.enableConsoleLogging) {
            consoleLogger.log(level, message);
        }

        if (settings.enableApiLogging) {
            apiLogger.log(date, level, message);
        }
    }
}

function shouldLog(logLevel: LogLevels): boolean {
    const levels = ['Debug', 'Info', 'Warn', 'Error'];
    return levels.indexOf(logLevel) >= levels.indexOf(settings.logLevel);
}
